module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_title_3-b8e1ffee93c4042ebf4ff21dabfbb77f.svg";